import React from 'react';

import {
    RicBeaconFooter,
    RicBeaconNavigationFooter,
    RicBeaconSocialLink,
    RicBeaconSocialLinkContainer
} from '../BeaconRegister';

const RAS_COPYRIGHT = `
    ©${(new Date()).getFullYear()} T. Rowe Price. All Rights Reserved. T. ROWE PRICE, INVEST WITH CONFIDENCE, and the Bighorn Sheep design are, collectively and/or apart,
    trademarks of T. Rowe Price Group, Inc. RETIRE WITH CONFIDENCE, T. ROWE PRICE INSIGHTS, ACTIVEPLUS PORTFOLIOS, and GOTUITION and design,
    are trademarks of T. Rowe Price Group, Inc. All other trademarks shown are the property of their respective owners. Use does not imply endorsement,
    sponsorship, or affiliation of T. Rowe Price with any of the trademark owners.`;

const AdviceFooter = ({
    copyrightContentOverride,
    disclosures,
    disclosuresOverrideStyles = { backgroundColor: '#00345C', paddingTop: '48px', paddingBottom: '48px', color: '#FFFFFF' }
}) =>
    <div className="beacon-theme-modern-outlook beacon-on-darker">
        {disclosures &&
            <div
                className='b-container'
                style={{
                    inlineSize: 'unset',
                    ...disclosuresOverrideStyles
                }}
            >
                {disclosures}
            </div>
        }
        <RicBeaconFooter>
            <div slot="trademark">
                Invest With Confidence<sup>®</sup>
            </div>
            <div slot="mission">
                We&apos;re driven by our purpose: To identify and actively invest in opportunities to help people thrive in an evolving world.
            </div>
            <RicBeaconNavigationFooter slot="links">
                <span slot="title">Company</span>
                <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href="https://www.troweprice.com/corporate/en/what-we-do.html"
                >Company Overview</a>
                <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href="https://www.troweprice.com/corporate/en/careers.html"
                >Careers</a>
                <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href="https://www.troweprice.com/corporate/en/press.html"
                >Newsroom</a>
                <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href="https://troweprice.gcs-web.com"
                >Investor Relations</a>
                <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href="https://www.troweprice.com/corporate/en/what-sets-us-apart/corporate-responsibility.html"
                >Responsibility</a>
            </RicBeaconNavigationFooter>
            <RicBeaconNavigationFooter slot="links">
                <span slot="title">Privacy & Legal</span>
                <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href="https://www.troweprice.com/enterprise/legal/us/en/privacy-notices.html"
                >U.S. and Canada Privacy Notice</a>
                <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href="https://www.troweprice.com/personal-investing/help/terms-of-use.html"
                >Terms of Use</a>
                <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href="https://www.troweprice.com/corporate/en/utility/security-measures.html"
                >Security Measures</a>
                <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href="https://www.troweprice.com/personal-investing/help/policies-and-security/legal-information.html"
                >Legal Information</a>
                <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href="https://www.troweprice.com/personal-investing/about-t-rowe-price/form-crs.html"
                >Form CRS</a>
                <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href="https://www.troweprice.com/en/us/accessibility.html"
                >Accessibility Statement</a>
            </RicBeaconNavigationFooter>
            <RicBeaconNavigationFooter slot="links">
                <span slot="title">Personal Investing</span>
                <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href="https://www.troweprice.com/personal-investing/sitemap.html"
                >Site Map</a>
                <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href="https://www.troweprice.com/corporate/en/mobile-solutions.html"
                >Mobile App</a>
                <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href="https://www.troweprice.com/personal-investing/help/contact-us.html"
                >Contact Us</a>
                <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href="https://www.troweprice.com/personal-investing/help/policies-and-security/customer-agreement.html"
                >Customer Agreement</a>
                <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href="https://www.troweprice.com/en/us/glossary.html"
                >Glossary</a>
                <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href="https://www.troweprice.com/en/us/market-data-disclosures.html"
                >Market Data Disclosure</a>
            </RicBeaconNavigationFooter>
            <RicBeaconSocialLinkContainer slot="socials">
                <p slot="text">Find us on:</p>
                <RicBeaconSocialLink>
                    <a
                        target='_blank'
                        rel='noopener noreferrer'
                        href="https://facebook.com/troweprice"
                    >Facebook</a>
                </RicBeaconSocialLink>
                <RicBeaconSocialLink>
                    <a
                        target='_blank'
                        rel='noopener noreferrer'
                        href="https://x.com/troweprice"
                    >X</a>
                </RicBeaconSocialLink>
                <RicBeaconSocialLink>
                    <a
                        target='_blank'
                        rel='noopener noreferrer'
                        href="https://youtube.com/trowepricegroup"
                    >YouTube</a>
                </RicBeaconSocialLink>
                <RicBeaconSocialLink>
                    <a
                        target='_blank'
                        rel='noopener noreferrer'
                        href="https://linkedin.com/company/157329?trk=tyah"
                    >LinkedIn</a>
                </RicBeaconSocialLink>
                <RicBeaconSocialLink>
                    <a
                        target='_blank'
                        rel='noopener noreferrer'
                        href="https://instagram.com/t._rowe_price"
                    >Instagram</a>
                </RicBeaconSocialLink>
            </RicBeaconSocialLinkContainer>
            <div slot="disclaimer">
                <p>
                    <a
                        id='onetrust-link'
                        className='ot-sdk-show-settings'
                        href="/#"
                        role='button'
                        onClick={(e) => e.preventDefault()}
                    >
                        Do Not Sell or Share My Personal Information
                    </a>
                </p>
                <p>
                    The funds referred to in this website are offered and sold only to persons residing in the United States and are offered by prospectus
                    only. The prospectuses include investment objectives, risks, fees, expenses, and other information that you should read and consider
                    carefully before investing. T. Rowe Price Investment Services, Inc., distributor, T. Rowe Price mutual funds and T. Rowe Price ETFs.
                </p>
                <p>
                    Download a <a target="_blank" rel="noopener noreferrer" href="https://www.troweprice.com/personal-investing/funds/mutual-funds/prospectuses-reports.html">mutual fund prospectus</a> or <a target="_blank" rel="noopener noreferrer" href="https://www.troweprice.com/personal-investing/funds/etfs/prospectuses-reports.html">ETF prospectus</a>.
                </p>
            </div>
            <div slot="copyright">
                <p>
                    {copyrightContentOverride ? copyrightContentOverride : RAS_COPYRIGHT}
                </p>
            </div>
        </RicBeaconFooter>
    </div>;

export default AdviceFooter;
